/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BannedItemResponseDTOFromJSON, BannedItemResponseDTOToJSON, } from './BannedItemResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseBannedItemResponseDTO interface.
 */
export function instanceOfPaginatedResponseBannedItemResponseDTO(value) {
    return true;
}
export function PaginatedResponseBannedItemResponseDTOFromJSON(json) {
    return PaginatedResponseBannedItemResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseBannedItemResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(BannedItemResponseDTOFromJSON)),
    };
}
export function PaginatedResponseBannedItemResponseDTOToJSON(json) {
    return PaginatedResponseBannedItemResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseBannedItemResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(BannedItemResponseDTOToJSON)),
    };
}
